import BaseDivider from '@material-ui/core/Divider'

const Divider = BaseDivider

export default Divider
